import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { dataAttribute } from "@contember/utilities";
import { memo, forwardRef } from "react";
import { useTextBasedInput } from "../Hooks/useTextBasedInput.js";
import { toViewClass } from "../../../utils/toViewClass.js";
const EmailInput = memo(forwardRef(({
  className,
  focusRing = true,
  withTopToolbar,
  ...outerProps
}, forwardedRed) => {
  const props = useTextBasedInput({
    ...outerProps,
    className: useClassName(["text-input", "email-input"], [
      toViewClass("withTopToolbar", withTopToolbar),
      className
    ])
  }, forwardedRed);
  return /* @__PURE__ */ jsx("input", { "data-focus-ring": dataAttribute(focusRing), ...props, type: "email" });
}));
EmailInput.displayName = "EmailInput";
export {
  EmailInput
};
//# sourceMappingURL=EmailInput.js.map
